"use strict";

exports.__esModule = true;
exports.TOOL_PERFORMANCE = exports.PERFORMANCE_GRID = exports.PART_METRICS = exports.OPERATOR_METRICS = exports.HOURLY_ACTIVITY_SUMMARY = exports.CONDITIONS = exports.ACTIVITY_SUMMARY = void 0;
var _react = _interopRequireDefault(require("react"));
var _ReportThumbnail = require("./ReportThumbnail");
var _constants = require("../../Auth/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ACTIVITY_SUMMARY = exports.ACTIVITY_SUMMARY = {
  name: "Activity Summary",
  id: _constants.REPORT_ACTIVITY_SUMMARY,
  description: "View the the Pareto of all activities that happened for the entire plant and also by machine",
  permission: "VIEW_ACTIVITY_SUMMARY",
  path: "/analytics-new/activity-summary",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_ACTIVITY_SUMMARY
    }));
  }
};
var HOURLY_ACTIVITY_SUMMARY = exports.HOURLY_ACTIVITY_SUMMARY = {
  name: "Hourly Activity Summary",
  id: _constants.REPORT_HOURLY_ACTIVITY_SUMMARY,
  description: "See summary of all activities by each hour of day across selected days",
  permission: "VIEW_HOURLY_ACTIVITY_SUMMARY",
  path: "/analytics-new/hourly-activity-summary",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_HOURLY_ACTIVITY_SUMMARY
    }));
  }
};
var PERFORMANCE_GRID = exports.PERFORMANCE_GRID = {
  name: "Performance Grid",
  id: _constants.REPORT_PERFORMANCE_GRID,
  description: "View performance of a device or a set of devices or device group with metrics like OEE,Staffed Utilization and more",
  permission: "VIEW_PERFORMANCE_GRID_REPORT",
  path: "/analytics-new/performance",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_PERFORMANCE_GRID
    }));
  }
};
var PART_METRICS = exports.PART_METRICS = {
  name: "Part Metrics",
  id: _constants.REPORT_PART_METRICS,
  description: "Deep dive into the details of parts made with metrics like quality, good and bad count and more",
  permission: "VIEW_PART_METRICS",
  path: "/analytics-new/part-metrics",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_PART_METRICS
    }));
  }
};
var OPERATOR_METRICS = exports.OPERATOR_METRICS = {
  name: "Operator Metrics",
  id: _constants.REPORT_OPERATOR_METRICS,
  description: "View metrics for an operator across each device the operator(s) has worked on",
  permission: "VIEW_OPERATOR_METRICS",
  path: "/analytics-new/operator-metrics",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_OPERATOR_METRICS
    }));
  }
};
var TOOL_PERFORMANCE = exports.TOOL_PERFORMANCE = {
  name: "Tool Performance",
  id: _constants.REPORT_TOOL_PERFORMANCE,
  description: "View the cutting duration of the tool used on the device and by part",
  permission: "VIEW_TOOL_PERFORMANCE",
  path: "/analytics-new/tool-performance",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_TOOL_PERFORMANCE
    }));
  }
};
var CONDITIONS = exports.CONDITIONS = {
  name: "Conditions",
  id: _constants.REPORT_CONDITIONS,
  description: "View summary and details of machine faults and warnings",
  permission: "VIEW_CONDITIONS",
  path: "/analytics-new/conditions",
  thumbnail: function thumbnail(props) {
    return /*#__PURE__*/_react["default"].createElement(_ReportThumbnail.ReportThumbnail, _extends({}, props, {
      reportKey: _constants.REPORT_CONDITIONS
    }));
  }
};